const TOKEN_COOKIE_PATH = '/'
const TOKEN_COOKIE_DOMAIN = '.liefersoft.de'

const getTokenCookieExpires = (minutes = 60 * 24 * 30) => {
	const date = new Date()
	date.setTime(date.getTime() + minutes * 60000)
	return date.toUTCString()
}

const getCookieValue = (name) => {
	const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
	return match ? match[1] : null
}

const removeDomainCookie = (name) => {
	document.cookie = `${name}=; Domain=${TOKEN_COOKIE_DOMAIN}; Path=${TOKEN_COOKIE_PATH}; SameSite=Lax; Expires=Thu, 01 Jan 1970 00:00:00 GMT;`
}

export const getCookieAccessToken = () => getCookieValue('accessToken')
export const getCookieRefreshToken = () => getCookieValue('refreshToken')

export const setCookieTokens = (accessToken, refreshToken) => {
	const expires = getTokenCookieExpires()
	document.cookie = `accessToken=${accessToken}; Path=${TOKEN_COOKIE_PATH}; SameSite=Lax; Expires=${expires};`
	document.cookie = `refreshToken=${refreshToken}; Path=${TOKEN_COOKIE_PATH}; SameSite=Lax; Expires=${expires};`
}

export const removeCookieTokens = () => {
	document.cookie = `accessToken=; Path=${TOKEN_COOKIE_PATH}; SameSite=Lax; Expires=Thu, 01 Jan 1970 00:00:00 GMT;`
	document.cookie = `refreshToken=; Path=${TOKEN_COOKIE_PATH}; SameSite=Lax; Expires=Thu, 01 Jan 1970 00:00:00 GMT;`
	removeDomainCookie('accessToken')
	removeDomainCookie('refreshToken')
}

export const cleanupDomainCookies = () => {
	const accessToken = getCookieAccessToken()
	const refreshToken = getCookieRefreshToken()
	if (!accessToken) return

	setCookieTokens(accessToken, refreshToken)
	removeDomainCookie('accessToken')
	removeDomainCookie('refreshToken')
}
